export const buildLoginRedirect = (target: string) =>
  `/login?redirect=${encodeURIComponent(target)}`;
